// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PricingQueryInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Query-string input for GET /ai/credits/pricing.
 *
 * Optional:
 *   model       (string|null) — AI model identifier; defaults server-side to 'deepseek-v4-flash'
 *   franquia_id (int|null)    — when present, checks for a per-franchise override first
 */
import { registerContract } from './validate'

export interface AiCredits_PricingQueryInput {
model?: string
franquia_id?: number
}

registerContract('AiCredits_PricingQueryInput', {
  model:       { type: 'string',  required: false },
  franquia_id: { type: 'number',  required: false },
})
